import React from "react";
import  { useState, useEffect } from 'react';
import './classes/RugbyEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const MikeAblettTestimonial = () => {

    const app_url = configData.APP_URL;
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Promise.all([
         
        ])
        .then(() => {
     
        setIsLoading(false);
        })
    },[]);

    const doBackAway = () => {
        if (window.history.length > 1) {
            navigate(-1); // Go back
        } else {
            navigate('/'); // Fallback to home
        }
    };
     

    return (
        <>
        {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" style={{minHeight: "400px"}} className="steve-wisensale-testimonial-main">
                <Helmet><title>Mike Ablett</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div style={{float: "left"}}>
                        <img src="/basic/web/images/scout/picture-2556-1454348562.jpg" alt="Mike Ablett" style={{"width":"100px"}} />
                    </div>
                    <div style={{float:"left", paddingLeft:"2%", paddingTop:"2%"}}><strong>Mike Ablett</strong></div>
                    <div style={{textAlign: "right"}}><a href onClick={doBackAway} style={{cursor: "pointer"}}>« Back</a></div>
                    <div style={{clear:"both"}}></div>
                    <div style={{marginBottom: "8px"}}>
                        <p style={{marginTop: "0px"}}>
                            The Rugby Business Management Course is a must for any one who is involved in Rugby or is looking at pursuing a career in Rugby Administration. The personal attention and weekly audio chats were great and it created an open forum to compare, debate and analyze the game we love. 
                        </p>
                    </div>
                </div>
                <div className="right">
                       {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                        {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default MikeAblettTestimonial;